import { privateApi } from 'services';
import { ContentLibraryImage } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchImages = (businessAccountId: string): Promise<ContentLibraryImage[]> =>
    privateApi.get<ContentLibraryImage[]>(`business-accounts/${businessAccountId}/content-library/image-items`);

const uploadImage = async (
    businessAccountId: string,
    formData: FormData,
    onProgressChange?: (e: ProgressEvent<XMLHttpRequestEventTarget>) => void,
): Promise<unknown> =>
    privateApi.postMultipart(
        `business-accounts/${businessAccountId}/content-library/image-items`,
        formData,
        false,
        onProgressChange,
    );

const archiveContentLibraryImage = (imageId: string): Promise<ContentLibraryImage> =>
    privateApi.post<ContentLibraryImage>(`content-library/image-items/${imageId}/archive`, {});

const unarchiveContentLibraryImage = (imageId: string): Promise<ContentLibraryImage> =>
    privateApi.post<ContentLibraryImage>(`content-library/image-items/${imageId}/unarchive`, {});

const deleteContentLibraryImage = (imageId: string): Promise<ContentLibraryImage> =>
    privateApi.post<ContentLibraryImage>(`content-library/image-items/${imageId}/delete`, {});

export const ContentLibraryImageGateway = {
    fetchImages,
    uploadImage,
    archiveContentLibraryImage,
    unarchiveContentLibraryImage,
    deleteContentLibraryImage,
};

const cancelableFetchImages = (businessAccountId: string): Promise<ContentLibraryImage[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<ContentLibraryImage[]>(
        `business-accounts/${businessAccountId}/content-library/image-items`,
    );

const cancelableDeleteImage = (imageId: string, customEventName: string): Promise<ContentLibraryImage> =>
    privateApiWithRouteLeavingCancelation.postWithAbortControlOnCustomEvent<ContentLibraryImage>(
        `content-library/image-items/${imageId}/delete`,
        {},
        { customEventName },
    );

export const CancelableContentLibraryImageGateway = {
    cancelableFetchImages,
    cancelableDeleteImage,
};
